import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function Footer() {
  const mainArticles = allArticles.slice(0, 5);

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-base font-semibold font-heading text-background-50 mb-3">
              VigorBuy Spreadsheet
            </h3>
            <p className="text-xs text-background-400 leading-relaxed">
              Trusted resources, buying guides, QC tutorials, and expert tips to help you navigate VigorBuy with confidence.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50 mb-3">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="#categories" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Categories
                </a>
              </li>
              <li>
                <a href="#features" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Features
                </a>
              </li>
              <li>
                <a href="#compare" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  Comparison
                </a>
              </li>
              <li>
                <a href="#faq" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50 mb-3">
              Resources
            </h4>
            <ul className="space-y-2">
              {mainArticles.map((article) => (
                <li key={article.slug}>
                  <Link to={`/${article.slug}/`} className="text-xs text-background-400 hover:text-background-100 transition-colors line-clamp-1">
                    {article.title}
                  </Link>
                </li>
              ))}
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-400 hover:text-background-100 transition-colors">
                  VigorBuy Sheet
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50 mb-3">
              More Articles
            </h4>
            <ul className="space-y-2">
              {allArticles.slice(5, 10).map((article) => (
                <li key={article.slug}>
                  <Link to={`/${article.slug}/`} className="text-xs text-background-400 hover:text-background-100 transition-colors line-clamp-1">
                    {article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} VigorBuy Spreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            This site is an independent resource and is not affiliated with any specific platform.
          </p>
        </div>
      </div>
    </footer>
  );
}